module.exports = __webpack_public_path__ + "static/media/icon_chair.5cdf43a7.svg";